const wkDataInterrogator = {
  isAlbum() {
    return wkData.product.type === 'album';
  },

  isCalendar() {
    return window.wkData.product.type === 'calendar';
  }
};

export default wkDataInterrogator;
